/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ summary: NonNullable<unknown> }} Ui_Delete_Dialog_CountInputs */

const en_ui_delete_dialog_count = /** @type {(inputs: Ui_Delete_Dialog_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.summary} will be deleted.`)
};

const de_ui_delete_dialog_count = /** @type {(inputs: Ui_Delete_Dialog_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.summary} werden gelöscht.`)
};

/**
* | output |
* | --- |
* | "{summary} will be deleted." |
*
* @param {Ui_Delete_Dialog_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_delete_dialog_count = /** @type {((inputs: Ui_Delete_Dialog_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Delete_Dialog_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_delete_dialog_count(inputs)
	return de_ui_delete_dialog_count(inputs)
});